import React from 'react'

const SvgBanOutline = (props: React.SVGProps<SVGSVGElement>) => (
  <svg width='1em' height='1em' viewBox='0 0 24 24' {...props}>
    <path d='M20 12a7.948 7.948 0 01-1.688 4.897L7.103 5.688A7.954 7.954 0 0112 4c4.411 0 8 3.589 8 8zM4 12c0-1.846.634-3.542 1.688-4.897l11.209 11.209A7.954 7.954 0 0112 20c-4.411 0-8-3.589-8-8zm-2 0c0 5.514 4.486 10 10 10s10-4.486 10-10S17.514 2 12 2 2 6.486 2 12z' />
  </svg>
)

export default SvgBanOutline
